import React, { Component } from "react";
import MinNav from "../component/MinNav";
import CategoryTable from "./CategoryTable";

class AllCategories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categories: [],
      category: '',
      storeState: true
    };

    this.delete = this.delete.bind(this);
    this.update = this.update.bind(this);
    this.insert = this.insert.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  delete(e) {
    if (window.confirm('Delete this category')) {
      let categoryID = e.target.getAttribute("data-id");
      fetch(`${this.props.apiROOT}category/delete/${categoryID}`)
        .then(res => res.json())
        .then(data => {
          if (data.status) {
            this.setState({ categories: data.categories });
          }
        });
    }
  }

  update(e) {
    let btn = e.target;
    btn.innerHTML = 'Please wait...'
    let categoryID = e.target.getAttribute("data-id");
    let formData = new FormData();
    let visibility = document.querySelector(`.update-category-visibility-${categoryID}`).checked;
    
    if (visibility) {
      formData.append('admin', 1);
    } else {
      formData.append('admin', 0);
    }

    let category = document.querySelector('.cat-ad-' + categoryID).value;
    formData.append('category', category.replace(/-/g, " "));
    fetch(`${this.props.apiROOT}category/update/${categoryID}`, { method: 'post', body: formData })
      .then(res => res.json())
      .then(data => {
        if (data.status) {
          btn.innerHTML = 'Update';
          document.querySelector('.ad-category-input').value = '';
          this.setState({ categories: data.categories });
          alert('Category updated successfully');
        }
      });
  }

  onChange(e) {
    this.setState({ storeState: false });
    let category = e.target.value;
    this.setState({ category: category });
  }

  insert(e) {
    e.target.innerHTML = 'Please wait...'
    this.setState({ storeState: false });
    let formData = new FormData();
    let visibility = document.querySelector('.add-category-visibility').checked;
    
    if (visibility) {
      formData.append('admin', 1);
    } else {
      formData.append('admin', 0);
    }
    
    formData.append('category', this.state.category.replace(/-/g, " "));
    fetch(`${this.props.apiROOT}category/insert`, { method: 'post', body: formData })
      .then(res => res.json())
      .then(data => {
        if (data.status) {
          document.querySelector('.ad-category-button').innerHTML = 'Add Category';
          document.querySelector('.ad-category-input').value = '';
          this.setState({ categories: data.categories });
          alert('Category created successfully');
        }
      })
      .catch(err => {
        console.log(err);
      });
  }

  componentDidMount() {
    fetch(`${this.props.apiROOT}category/fetch`)
      .then(res => res.json())
      .then(data => {
        if (data.categories == null) return;
        this.setState({
          categories: data.categories
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  render() {
    return (
      <div className="a-container">
        <MinNav />
        <div className="" style={{ width: 290 + "px", margin: 10 + 'px auto' }}>

          <div className="input-wrapper">
            <input type="text" placeholder="Add category" onChange={this.onChange} className="ad-category-input" />
          </div>

          <div class="input-wrapper">
            <div className="LoginFormCheckboxWrapper">
              <label>Click to make it visible to admin only</label>
              <input type="checkbox" name="visibility" className="add-category-visibility" />
            </div>
          </div>

          <a href="#">
            <button className="btn shadow ad-category-button"
              onClick={this.insert}
              style={{ margin: 5 + ' auto', backgroundColor: 'green' }}>Add Category</button>
          </a>
        </div>

        <CategoryTable
          categories={this.state.categories}
          apiROOT={this.props.apiROOT}
          delete={this.delete}
          update={this.update}
        />
      </div>
    );
  }
}

export default AllCategories;
